<template class="bg-white">
    <main id="Message_Center">
        <PageLayout :has-title="false" content-class="p-0">
            <template v-slot:content>
                <section class="row mx-0 h-100" id="MessageCenter__List">
                    <nav class="chat-nav-list px-0" :class="`${userOs == 'Windows' ? 'custom-scrollbar' : ''}`">
                        <ul class="nav list-group list-group-flush">
                            <!-- <li style="height: 3.5rem" class="nav-item list-group-item" @click="toggleAgencyNav">
                                <div class="d-flex flex-column align-items-center h-100">
                                    <img v-show="agencyNavOpened" src="../../assets/images/chat/drawer-collapse.svg" />
                                    <img v-show="!agencyNavOpened" src="../../assets/images/chat/drawer-expand.svg" />
                                </div>
                            </li> -->
                            <!-- <li
                                class="nav-item list-group-item"
                                :class="{ 'active-tab': activeChatNav === ChatNavOptionsEnum.Profile }"
                                @click="chatNavSelected(ChatNavOptionsEnum.Profile)"
                            >
                                <div class="d-flex flex-column align-items-center h-100">
                                    <i class="far fa-user"></i>
                                    <span> Profile</span>
                                </div>
                            </li> -->
                            <li
                                style="height: 4rem"
                                class="nav-item list-group-item"
                                :class="{ 'active-tab': activeChatNav === ChatNavOptionsEnum.Chat }"
                                @click="chatNavSelected(ChatNavOptionsEnum.Chat)"
                            >
                                <div class="d-flex flex-column align-items-center pt-1 px-1 h-100">
                                    <span>
                                        <img
                                            v-show="activeChatNav !== ChatNavOptionsEnum.Chat"
                                            src="../../assets/images/chat/messenger-inactive.svg"
                                        />
                                        <img
                                            v-show="activeChatNav === ChatNavOptionsEnum.Chat"
                                            src="../../assets/images/chat/messenger-active.svg"
                                        />
                                        <sup class="unread-message-badge"
                                            ><span class="badge bg-primary px-1" v-if="unreadConvIds?.length > 0">{{
                                                unreadConvIds.length
                                            }}</span></sup
                                        >
                                    </span>
                                    <span><small class="fw-normal">Chat</small></span>
                                </div>
                            </li>
                            <li
                                style="height: 4rem"
                                class="nav-item list-group-item"
                                :class="{ 'active-tab': activeChatNav === ChatNavOptionsEnum.Call }"
                                @click="chatNavSelected(ChatNavOptionsEnum.Call)"
                            >
                                <div class="d-flex flex-column align-items-center pt-1 px-1 h-100">
                                    <img
                                        v-show="activeChatNav !== ChatNavOptionsEnum.Call"
                                        src="../../assets/images/chat/phone-inactive.svg"
                                    />
                                    <img
                                        v-show="activeChatNav === ChatNavOptionsEnum.Call"
                                        src="../../assets/images/chat/phone-active.svg"
                                    />
                                    <span><small class="fw-normal">Calls</small></span>
                                </div>
                            </li>
                            <li
                                v-if="hasTestAgency"
                                style="height: 4rem"
                                class="nav-item list-group-item"
                                :class="{ 'active-tab': activeChatNav === ChatNavOptionsEnum.Calendar }"
                                @click="chatNavSelected(ChatNavOptionsEnum.Calendar)"
                            >
                                <div class="d-flex flex-column align-items-center pt-1 px-1 h-100">
                                    <img
                                        v-show="activeChatNav !== ChatNavOptionsEnum.Calendar"
                                        src="../../assets/images/chat/calendar-inactive.svg"
                                    />
                                    <img
                                        v-show="activeChatNav === ChatNavOptionsEnum.Calendar"
                                        src="../../assets/images/chat/calendar-active.svg"
                                    />
                                    <span><small class="fw-normal">Calendar</small></span>
                                </div>
                            </li>
                            <li
                                v-if="hasFamilyPortalPermission"
                                style="height: 6rem"
                                class="nav-item list-group-item"
                                :class="{ 'active-tab': activeChatNav === ChatNavOptionsEnum.FamilyPortal }"
                                @click="chatNavSelected(ChatNavOptionsEnum.FamilyPortal)"
                            >
                                <div class="d-flex flex-column align-items-center pt-1 px-1 h-100">
                                    <span>
                                        <img
                                            class="family-portal-icon"
                                            v-show="activeChatNav !== ChatNavOptionsEnum.FamilyPortal"
                                            src="../../assets/images/chat/family-portal-icon.svg"
                                        />
                                        <img
                                            class="family-portal-icon"
                                            v-show="activeChatNav === ChatNavOptionsEnum.FamilyPortal"
                                            src="../../assets/images/chat/family-portal-icon.svg"
                                        />
                                        <sup class="unread-thread-badge"
                                            ><span class="badge bg-primary px-1" v-if="totalUnreadThreadCount > 0">{{
                                                totalUnreadThreadCount
                                            }}</span></sup
                                        >
                                    </span>
                                    <span
                                        ><small class="fw-normal">Family <br />Portal</small></span
                                    >
                                </div>
                            </li>
                        </ul>
                    </nav>
                    <nav
                        class="message-list overflow-auto"
                        :class="`${userOs == 'Windows' ? 'custom-scrollbar' : ''}`"
                        v-show="
                            (!isMobile || !hideNav || (!newConversation && isMobile)) &&
                            activeChatNav === ChatNavOptionsEnum.Chat
                        "
                    >
                        <ScrollPagination
                            class="content-y h-100 d-flex flex-column"
                            :page-number="convPagination.currentPage"
                            :all-pages-loaded="allPagesLoaded"
                            :is-loading="isLoading"
                            :has-error="hasError"
                            v-on:pageNumberUpdate="pageNumberUpdated"
                        >
                            <ConversationNav
                                :is-loading="isLoading"
                                :page-number="convPagination.currentPage"
                                :new-conversation="newConversation"
                                @termChanged="updateChatSearchTerm"
                                @sortByChanged="updateSortBy"
                            />
                        </ScrollPagination>
                    </nav>
                    <section
                        class="col px-0 h-100 overflow-auto chat-view"
                        v-show="
                            (!isMobile || (isMobile && newConversation)) && activeChatNav === ChatNavOptionsEnum.Chat
                        "
                    >
                        <router-view />
                    </section>
                    <nav
                        class="message-list overflow-auto"
                        :class="`${userOs == 'Windows' ? 'custom-scrollbar' : ''}`"
                        v-show="(!isMobile || !hideNav) && activeChatNav === ChatNavOptionsEnum.Call"
                    >
                        <ul class="list-group-flush">
                            <li class="nav-item list-group-item message-list-itemm nav-list-header calls-list-header">
                                <div class="d-flex align-items-center h-100">
                                    <h5 class="fw-bold mb-0 ms-2 text-app-secondary">Calls</h5>
                                </div>
                            </li>
                            <li class="search-input p-3 bg-white">
                                <CallSearch />
                            </li>
                        </ul>
                    </nav>
                    <section
                        v-if="hideNav && activeChatNav === ChatNavOptionsEnum.Call"
                        class="call-list col px-0 h-100 overflow-auto"
                    >
                        <CallHistory />
                    </section>
                    <section
                        v-if="(!isMobile || hideNav) && activeChatNav === ChatNavOptionsEnum.Calendar"
                        class="col px-0 h-100 overflow-auto"
                    >
                        <MeetingCalendar />
                    </section>
                    <section
                        v-if="(!isMobile || hideNav) && activeChatNav === ChatNavOptionsEnum.FamilyPortal"
                        class="col px-0 h-100 overflow-auto"
                    >
                        <FamilyPortal />
                    </section>
                </section>
            </template>
        </PageLayout>
    </main>
</template>

<style src="./MessageCenter.scss"></style>
<script lang="ts" src="./MessageCenter.ts"></script>
